<template>
  <app-layout title="Заявки">
    <div class="wrapper">
      <div class="leftbar leftbar_margin-right">
        <div class="results results_margin-bottom results_padding-first">
          <div class="title title_padding-bottom">текущие итоги по выкупам</div>
          <div class="results__wrapper-line">
            <div class="line line_margin-right">
              <div class="line__item line__item_green"
                   :style="`height: ${Math.round((summary[9].sum) / (totalSum) * 100)}%`"></div>
              <div class="line__item line__item_red"
                   :style="`height: ${Math.round(summary[11].sum / totalSum * 100)}%`"></div>
              <div class="line__item line__item_blue"
                   :style="`height: ${Math.round((summary[5].sum + summary[6].sum) / totalSum * 100)}%`"></div>
              <div class="line__item line__item_yellow"
                   :style="`height: ${Math.round(summary[4].sum / totalSum * 100)}%`"></div>
            </div>
            <div>
              <div class="results__item">
                <a href="#" class="results__status results__status_green">Приняты и ждут оплаты</a>
                <div class="results__count">
                  {{ formatPrice(summary[9].count) }} шт.
                </div>
                <div class="results__price">
                  {{ formatPrice(summary[9].sum) }}
                  <span>руб.</span>
                </div>
              </div>
              <div class="results__item">
                <a href="#" class="results__status results__status_red">Претензия</a>
                <div class="results__count">
                  {{ formatPrice(summary[11].count) }} шт.
                </div>
                <div class="results__price">
                  {{ formatPrice(summary[11].sum) }}
                  <span>руб.</span>
                </div>
              </div>
              <div class="results__item">
                <a href="#" class="results__status results__status_blue">В пути</a>
                <div class="results__count">
                  {{ formatPrice(summary[5].count + summary[6].count) }} шт.
                </div>
                <div class="results__price">
                  {{ formatPrice(summary[5].sum + summary[6].sum) }}
                  <span>руб.</span>
                </div>
              </div>
              <div class="results__item">
                <a href="#" class="results__status results__status_yellow">В магазинах</a>
                <div class="results__count">
                  {{ formatPrice(summary[4].count) }} шт.
                </div>
                <div class="results__price">
                  {{ formatPrice(summary[4].sum) }}
                  <span>руб.</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="results results_padding-second total">
          <div class="title title_padding-bottom">общие итоги выкупов</div>
          <div class="total__item total__item_margin-bottom">
            <div class="total__title">Выкуплено:</div>
            <div class="total__price">
              {{ formatPrice(summary[10].sum) }}
              <span>руб. / {{ formatPrice(summary[10].count) }} шт.</span>
            </div>
          </div>
          <div class="total__item">
            <div class="total__title">Не оплачено:</div>
            <div class="total__price">{{ formatPrice(totalSum) }}
              <span>руб. / {{ formatPrice(totalCount - summary[10].count) }} шт.</span>
            </div>
          </div>
        </div>
      </div>


      <div class="rightbar">
        <div class="title title_low-padding-bottom">выкупы по дням</div>
        <div class="rightbar__list-scroll">
          <ul class="rightbar__list">
            <li class="rightbar__list-item">
              <span>Дата</span>
              <div class="rightbar__container">
                <span class="rightbar__container-item">Кол-во</span>
                <span class="rightbar__container-item">На сумму</span>
              </div>
            </li>
            <li class="rightbar__list-item"
                v-for="(order, idx) in this.orders.data" :key="idx">
              <span class="rightbar__list-item-date">{{ moment(order.date).format('DD MMM YYYY') }}</span>
              <div class="rightbar__container">
                <span class="rightbar__container-item">{{ formatPrice(order.count) }} шт.</span>
                <span class="rightbar__container-item">{{ formatPrice(order.sum) }} руб.</span>
              </div>
            </li>
          </ul>
        </div>

        <div class="rightbar__pagination">
          <div class="rightbar__arrow rightbar__arrow_left"
               :class="orders.page === 1 ? 'rightbar__arrow_no-active' : ''"
               @click="orders.page !== 1 ? getDayOrders(orders.page - 1) : null"></div>
          <div class="rightbar__pagination-item"
               :class="orders.page === 1 ? 'rightbar__pagination-item_active' : ''"
               @click="getDayOrders(orders.page - 1)">
            {{ orders.page === 1 ? orders.page : orders.page - 1 }}
          </div>
          <div class="rightbar__pagination-item"
               :class="orders.page !== 1 ? 'rightbar__pagination-item_active' : ''"
               @click="orders.page === 1 ? getDayOrders(orders.page + 1) : null">
            {{ orders.page === 1 ? orders.page + 1 : orders.page }}
          </div>
          <div class="rightbar__pagination-item" @click="getDayOrders(orders.page + 1)">
            {{ orders.page === 1 ? orders.page + 2 : orders.page + 1 }}
          </div>
          <div class="rightbar__arrow" @click="getDayOrders(orders.page + 1)"></div>
        </div>
      </div>
    </div>
  </app-layout>
</template>


<script>
  import AppLayout from '../components/AppLayout.vue';
  import { fetchDayByDayStatistic, fetchOrdersStatistic } from '../api';

  export default {
    name: "Summary",

    components: {
      AppLayout,
    },

    data () {
      return {
        summary: {},
        orders: {}
      }
    },

    mounted() {
      this.getDayOrders(1);

      fetchOrdersStatistic().then(res=> {
        this.summary = res;
      })
    },

    computed: {
      totalSum () {
        return Object.values(this.summary).reduce((a, b) => {
          return a.sum ? a.sum + b.sum : a + b.sum;
        }) - this.summary[10].sum;
      },

      totalCount () {
        return Object.values(this.summary).reduce((a, b) => {
          return a.count ? a.count + b.count : a + b.count;
        });
      }
    },

    methods: {
      formatPrice(value) {
        let val = (value/1)
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
      },

      getDayOrders(page) {
        fetchDayByDayStatistic({page: page, limit: 13}).then(res=> {
          this.orders = res;
        })
      }
    }
  }
</script>

<style lang="sass">
  @import '@/styles/components/summary.sass'
</style>
